function initialRedirect($link) {
    if ($link) {
        document.addEventListener('wpcf7mailsent', function (event) {
            window.location.href = $link;
        }, false);
    }
}
export default initialRedirect;
